/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import _ from 'lodash'
import uuid from 'uuid'
import { Button } from '@styles/button.style'
import TodayPickProfileImg from '@assets/images/bg/character/today-pick.png'
import { ModalBg } from '@styles/base.style'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import Login from '@views/Login'
import { MatchVersusWrap } from '@styles/match.style'
import dayjs from 'dayjs'
import ChatPickBtnImg from '@assets/images/btn/chat-pick-btn.jpg'
import { Schema$CompanyPick } from '@interface/company-pick'
import { EMPTY_ICON } from '@constants/index'
import { AdvEmpty } from '@components/AdvEmpty'
import { NewBadgeIco } from '@shared/Icon/EtcIcon'
import { PickNoticePopupWrap } from '../index.style'
import { BASIC_TEAM_EMBLEM_MAP } from '@shared/EmblemGroup'
import PopupUtils from '@utils/popup-utils'

const PickNoticePopup: React.FC = (props) => {
  const { globalStore, authStore, companyPickStore, logStore } = useRootStore()
  const { notice, isNewNotice } = companyPickStore
  const { content = '', companyPicks = [] } = notice

  const [pickNoticePopupClass, setPickNoticePopupClass] = useState('')
  const [modalBgClass, setModalBgClass] = useState('adv-hidden')

  const onClickPickNoticeCloseBtn = () => {
    if (!isMobile) {
      globalStore.closeDialog()
    }
  }

  const elemHeader = (
    <div className="pick-notice-header">
      <div className="pick-profile">
        <img src={TodayPickProfileImg} alt="프리미엄 분석가"/>
      </div>

      <div className="pick-notice">
        <div className="txt-box">
          <span className="author">
            프리미엄 분석가
          </span>
          <p className="txt">
            {content}
          </p>
        </div>
        <Button TP className="btn-bg" onClick={onClickPickNoticeCloseBtn}>
          <span className="cls-ico"/>
        </Button>
      </div>
    </div>
  )

  const onClickPickDetail = (pick: Schema$CompanyPick) => {
    if (!authStore.isSignedIn) {
      authStore.showLoginPopup(<Login/>)
    } else {
      globalStore.closeDialog()
      companyPickStore.setSelectedCompanyPick(pick)
      PopupUtils.showCompanyPickDetailPopup()
    }
  }

  let elemBody: React.ReactElement
  if (!_.isEmpty(notice.companyPicks)) {
    elemBody = (
      <ul className="pick-list">
        {companyPicks.map((pick) => (
          <li key={pick.id ?? uuid.v4()} className="pick-list--item">
            <Button TP className="pick-btn" onClick={() => onClickPickDetail(pick)}>
              <MatchVersusWrap emblemSize={16}>
                <div className="team">
                  <img src={pick.homeTeamEmblem || BASIC_TEAM_EMBLEM_MAP[pick.sportId]} alt="홈팀 엠블럼" className="emblem"/>
                  <span className="team-name">{pick.homeTeamName}</span>
                </div>

                <div className="center">
                  <span className="vs">VS</span>
                  <span className="date">{dayjs(pick.dateOfMatch).format('MM/DD')}</span>
                  <span className="time">{dayjs(pick.dateOfMatch).format('HH:mm')}</span>
                </div>

                <div className="team">
                  <img src={pick.awayTeamEmblem || BASIC_TEAM_EMBLEM_MAP[pick.sportId]} alt="원정팀 엠블럼" className="emblem"/>
                  <span className="team-name">{pick.awayTeamName}</span>
                </div>
              </MatchVersusWrap>

              <div className="chat-pick-ico">
                <img src={ChatPickBtnImg} alt=""/>
              </div>

              <span className="line"/>
            </Button>
          </li>
        ))}
      </ul>
    )
  } else {
    elemBody = (
      <AdvEmpty ico={EMPTY_ICON.CHAT_PICK}/>
    )
  }

  const PickNoticePC: React.FC = () => {
    return (
      <PickNoticePopupWrap
        className={!_.isEmpty(notice.companyPicks) ? 'active pc-pick-notice-wrap' : 'no-pick active pc-pick-notice-wrap'}>
        {elemHeader}
        <div className={isMobile ? 'pick-notice-body' : 'pick-notice-body hover-effect'}>
          {elemBody}
        </div>
      </PickNoticePopupWrap>
    )
  }

  const onClickPCPickNotice = () => {
    logStore.writeButtonLog({ pageId: 'h010', buttonId: '004' }).catch(console.error)
    companyPickStore.saveLastVisibleNoticeId()
    companyPickStore.saveLastVisibleCompanyPickIdsInNotice()
    companyPickStore.updateIsNewNotice()

    globalStore.pushDialogOk({
      custom: <PickNoticePC/>,
      className: 'adv-new-dialog box-type big-size no-btn',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  const onClickPickNotice = () => {
    logStore.writeButtonLog({ pageId: 'h010', buttonId: '004' }).catch(console.error)
    companyPickStore.saveLastVisibleNoticeId()
    companyPickStore.saveLastVisibleCompanyPickIdsInNotice()
    companyPickStore.updateIsNewNotice()

    if (pickNoticePopupClass === '') {
      setPickNoticePopupClass('active')
      setModalBgClass('')
      if (_.isEmpty(notice.companyPicks)) {
        setPickNoticePopupClass('active no-pick')
      }
    } else {
      setPickNoticePopupClass('')
      setModalBgClass('adv-hidden')
    }
  }

  let pickNoticeContents: React.ReactElement
  if (isMobile) {
    pickNoticeContents = (
      <Fragment>
        {!_.isEmpty(notice.companyPicks) && <ModalBg className={modalBgClass}/>}
        <Button TP style={{ width: '100%', borderRadius: 14 }} onClick={onClickPickNotice}>
          {elemHeader}
          {!_.isEmpty(notice.companyPicks) &&
            <div className={isMobile ? 'pick-notice-body' : 'pick-notice-body hover-effect'}>
              {elemBody}
            </div>}
        </Button>
      </Fragment>
    )
  } else {
    pickNoticeContents = (
      <Button className="pick-notice-header-btn" onClick={onClickPCPickNotice}>
        {elemHeader}
      </Button>
    )
  }

  return (
    <Fragment>
      <PickNoticePopupWrap className={pickNoticePopupClass}>
        {pickNoticeContents}
        {/* 읽지않은 공지/픽이 있을 경우 */}
        {isNewNotice && <span className="new-badge"><NewBadgeIco/></span>}
      </PickNoticePopupWrap>
    </Fragment>
  )
}

export default observer(PickNoticePopup)
